<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<wa-button [routerLink]="['/plugins']" appearance="plain" variant="neutral">Back to Plugins</wa-button>
		<wa-card appearance="outlined">
			<div class="wa-stack wa-gap-m">
				<div class="wa-stack wa-gap-s">
					<h1 waHeading="xl" waText>C3.js</h1>
					<p waBody="m" waText>C3 makes it easy to generate D3-based charts by wrapping the code required to construct the entire chart. Supports line, bar, area, pie, donut, gauge, and scatter charts.</p>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25+</wa-tag>
						<wa-tag pill variant="neutral">C3 0.7.20</wa-tag>
						<wa-tag pill variant="neutral">D3-based</wa-tag>
						<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>COORDINATES &amp; MODULE</div>
					<p waBody="s" waText>Maven: com.jwebmp.plugins:c3</p>
					<p waBody="s" waText>JPMS Module: com.jwebmp.plugins.c3</p>
					<p waBody="s" waText>Built on: C3.js 0.7.20</p>
				</div>
				<wa-details summary="Installation">
					<div class="wa-stack wa-gap-xs">
						@if (!useGradle) {
							<div class="code-block-wrapper">
								<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Maven</div>
								<markdown [data]="mdContent_535" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
							</div>
						}
						@if (useGradle) {
							<div class="code-block-wrapper">
								<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Gradle &#40;Kotlin DSL&#41;</div>
								<markdown [data]="mdContent_536" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
							</div>
						}
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details summary="Features (4)">
					<div class="wa-stack wa-gap-xs">
						<p waBody="s" waColorText="quiet" waText>D3-based charting &mdash; line, bar, area, step, pie, donut, gauge, scatter</p>
						<p waBody="s" waColorText="quiet" waText>Type-safe Java API &mdash; C3Options, C3Data, C3Series with fluent methods</p>
						<p waBody="s" waColorText="quiet" waText>Auto npm integration &mdash; &#64;TsDependency + &#64;NgScript + &#64;NgStyleSheet</p>
						<p waBody="s" waColorText="quiet" waText>Zero configuration &mdash; auto-registered via ServiceLoader SPI</p>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="Examples (1)">
					<div class="wa-stack wa-gap-m">
						<div class="wa-stack wa-gap-xs">
							<h4 waHeading="s" waText>Create a C3 chart</h4>
							<p waBody="s" waColorText="quiet" waText>Use the C3 component with data columns.</p>
							<markdown [data]="mdContent_537" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
						</div>
					</div>
				</wa-details>
				<wa-details open summary="Quick Start">
					<markdown [data]="mdContent_538" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="SPI Extension Point Details (1)">
					<div class="wa-stack wa-gap-s">
						<div class="wa-stack wa-gap-xs">
							<div class="wa-cluster wa-gap-xs">
								<wa-tag pill variant="success">IPageConfigurator</wa-tag>
								<wa-tag pill variant="neutral">provides</wa-tag>
							</div>
							<p waBody="s" waColorText="quiet" waText>C3PageConfigurator auto-registers C3 JS/CSS via npm</p>
						</div>
					</div>
				</wa-details>
				<wa-details open summary="SPI Extension Points">
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">provides IPageConfigurator</wa-tag>
						</div>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="Prerequisites">
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25 LTS</wa-tag>
						<wa-tag pill variant="neutral">Maven 3.9+</wa-tag>
						<wa-tag pill variant="neutral">Node.js 18+</wa-tag>
						<wa-tag pill variant="neutral">Angular 21+</wa-tag>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<div class="wa-cluster wa-gap-s">
					<wa-tag pill variant="neutral">Upstream: https://c3js.org/</wa-tag>
					<wa-tag pill variant="neutral">Source: https://github.com/JWebMP/JWebMP</wa-tag>
				</div>
			</div>
		</wa-card>
	</div>
</div>